import { useContext } from 'react';
import { LoadingBarContext } from '@/context';

const usePageLoader = () => useContext(LoadingBarContext);

export default usePageLoader;
